<template>
  <div id="home" style="overflow-x: hidden">
    <!--POS-->
    <el-form label-position="left" :model="dataForm" :rules="rules" ref="posruleForm" label-width="150px" class="demo-ruleForm">
      <div style="background-color: white; margin: 10px 20px">
        <div class="pos_container_panel" style="padding-left: 10rem">
          <!--line1-->
          <el-row class="rowtop" style="padding-top: 2rem">
            <el-col :span="12">
              <el-form-item label="客户名称：" style="margin-bottom: 0; margin-left: 1rem">
                <el-input @click="showClientNamePop" readonly v-model="searchForm.client" placeholder="请选择" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light" style="float: right; margin-right: 120px">
                <el-button type="warning" v-if="this.btnshow == 2" @click="saveForm('posruleForm')">保存</el-button>
                <el-button type="warning" v-if="this.btnshow == 2" @click="cancel('posruleForm')">取消</el-button>
                <el-button type="warning" v-if="this.btnshow == 3" @click="editPos('add')">新增</el-button>
                <el-button type="warning" @click="editPos('edit')" v-if="this.btnshow == 1">修改</el-button>
              </div>
            </el-col>
          </el-row>
          <hr style="margin: 1rem -14rem 0rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;"/>
          <div class="border">
            <div class="border_title">
              <span>预订设置：</span>
            </div>
            <!--line2-->
            <el-row class="rowtop">
              <el-col :span="12">
                <el-form-item label="最大预定间夜数：" prop="maxNights" style="margin-bottom: 0; margin-left: 1rem">
                  <el-input :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.maxNights"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="每间人数：" prop="prePay" style="margin-bottom: 0; margin-left: 1rem">
                  <!-- <el-input :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.maxPerson"></el-input> -->
                  <el-select :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.maxPerson" placeholder="请选择">
                    <el-option v-for="item in optionsMaxPerson" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!--line4-->
            <el-row class="rowtop" >
              <el-col :span="12">
                <el-form-item label="每页条数：" prop="maxHotel" style="margin-bottom: 0; margin-left: 1rem">
                  <el-input :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.maxHotel"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最大预定房间数：" prop="prePay" style="margin-bottom: 0; margin-left: 1rem">
                  <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.maxRoom"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--line6-->
            <el-row class="rowtop">
              <el-col :span="12">
                <el-form-item label="最长的提前天数：" prop="maxAdvanceday" style="margin-bottom: 0; margin-left: 1rem">
                  <el-input :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.maxAdvanceday"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="默认货币：" prop="prePay" style="margin-bottom: 0; margin-left: 1rem">
                  <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.defultCry"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--line12-->
            <el-row class="rowtop">
              <el-col :span="12">
                <el-form-item label="超标管控：" prop="outofPolicy" style="margin-bottom: 0; margin-left: 1rem">
                  <el-select :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.outofPolicy" placeholder="请选择" @change="selectOutofPolicy">
                    <el-option v-for="item in options42" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="允许agent超标代订:" prop="agentOutOfPolicy" style="margin-bottom: 0; margin-left: 1rem">
                  <el-checkbox :disabled="this.showAgentOutOfPolicy" v-model="dataForm.agentOutOfPolicy"></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="预订其他产品:" style="margin-bottom: 0; margin-left: 1rem">
                <el-checkbox-group :disabled="posshow" v-model="dataForm.checkedProducts">
                  <el-checkbox label="PC" name="bookOtherPC"></el-checkbox>
                  <el-checkbox label="H5" name="bookOtherH5"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示渠道:" style="margin-bottom: 0; margin-left: 1rem">
                <el-row>
                  <el-col :span="12">
                    <el-form-item style="margin-bottom: 0;">
                      <el-checkbox :disabled="posshow" v-model="dataForm.isShowChannel"></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            </el-row>
            <el-row class="rowtop">
              <el-col :span="22">
                <el-form-item label="是否展示差规标识:" style="margin-bottom: 0; margin-left: 1rem">
                  <el-checkbox-group :disabled="posshow" v-model="dataForm.tripRuleChecked" @change="tripRuleChange">
                    <el-checkbox label="CN">大陆</el-checkbox>
                    <el-checkbox label="GAT">港澳台</el-checkbox>
                    <el-checkbox label="EN">国际</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="border" style="margin-left: 17rem;margin-right: 25rem;">
              <div class="border_title">
                <span>差规浮窗：</span>
              </div>
              <el-row class="rowtop">
                <el-col :span="12">
                  <el-form-item label="浮窗是否展示：" prop="isPopUp" style="margin-bottom: 0;">
                    <el-checkbox :disabled="posshow" v-model="dataForm.isTripRuleMarkInHotelList"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="浮窗个性化设置：" prop="isNavigationBarLabel" style="margin-bottom: 0;">
                    <el-checkbox :disabled="posshow" v-model="dataForm.isFloatWindowPersonalization"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="中文描述：" prop="descCn" style="margin-bottom: 0"  :rules="[
                      {
                        validator: tripRule_cn,
                        trigger: 'blur',
                      },
                    ]">
                    <el-input :disabled="isFloat" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.descCn"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="英文描述：" prop="descEn" style="margin-bottom: 0" :rules="[
                      {
                        validator: tripRule_en,
                        trigger: 'blur',
                      },
                    ]">
                    <el-input :disabled="isFloat" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.descEn"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="rowtop">
                <el-col :span="12">
                  <el-form-item label="可插入字段：" prop="sysParamPosFloatChose" style="margin-bottom: 0">
                    <el-select :disabled="isFloat" v-model="dataForm.sysParamPosFloatChose" placeholder="请选择" style="margin-left: 0px;width: 58%;" @change="selectSysConfigParam(true)">
                      <el-option v-for="item in dataForm.sysConfigParams"  :disabled="item.paramName === 'city' ? true : false" :key="item.paramValue" :label="item.paramName" :value="item.paramValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="插入位置选择：" prop="posFloatChose" style="margin-bottom: 0">
                    <el-select :disabled="isFloat" v-model="dataForm.posFloatChose"  style="margin-left: 0px;width: 58%;">
                      <el-option key="1" label="中文" value="1"></el-option>
                      <el-option key="2" label="英文" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row class="rowtop">
              <el-col :span="12">
                <el-form-item label="ChainWide酒店标识:" style="margin-bottom: 0; margin-left: 1rem;">
                  <el-checkbox :disabled="posshow" v-model="dataForm.isShowChainWide"></el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开启行后审批:" prop="isOpenLatterApproval" style="margin-bottom: 0; margin-left: 1rem">
                  <el-checkbox :disabled="this.posshow" v-model="dataForm.isOpenLatterApproval"></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        <div class="border">
          <div class="border_title">
            <span>开通资源：</span>
          </div>
          <!--line8-->
          <el-row class="rowtop">
            <el-col :span="8">
              <el-form-item label="仅展示最优价：" style="margin-bottom: 0;">
                <el-checkbox :disabled="posshow" v-model="dataForm.onlyShowBestPrice"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="8">
              <el-form-item label="大陆：" style="margin-bottom: 0;">
                <el-checkbox-group v-model="dataForm.openResources_D" :disabled="posshow" style="width:300px;">
                  <el-checkbox v-for="resource in openResource" :label="resource.key" :key="resource.key">{{resource.value}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="8">
              <el-form-item label="国际：" style="margin-bottom: 0;">
                <el-checkbox-group v-model="dataForm.openResources_I" :disabled="posshow" style="width:300px;">
                  <el-checkbox v-for="resource in openResource" :label="resource.key" :key="resource.key">{{resource.value}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="8">
              <el-form-item label="港澳台：" style="margin-bottom: 0;">
                <el-checkbox-group v-model="dataForm.openResources_O" :disabled="posshow" style="width:300px;">
                  <el-checkbox v-for="resource in openResource" :label="resource.key" :key="resource.key">{{resource.value}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="8">
              <el-form-item label="国际公付开票方式：" style="margin-bottom: 0;">
                <el-radio v-model="dataForm.invoicingMethods" :disabled="posshow" label="增值税普票">增值税普票</el-radio>
                <el-radio v-model="dataForm.invoicingMethods" :disabled="posshow" label="Einvoice">Einvoice</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="border">
          <div class="border_title">
            <span>价格过滤：</span>
          </div>
          <!--line3-->
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="过滤预付价格：" prop="prePay" style="margin-bottom: 0">
                <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.prePay"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="过滤非担保价格：" prop="NonGuaratee" style="margin-bottom: 0">
                <el-select :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.NonGuaratee" placeholder="请选择">
                  <el-option v-for="item in options32" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!--line5-->
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="过滤延时预定价格：" prop="burPrice" style="margin-bottom: 0">
                <el-select :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.burPrice" placeholder="请选择">
                  <el-option v-for="item in options52" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="过滤不可取消价格：" prop="nonRefund" style="margin-bottom: 0">
                <el-select :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.nonRefund" placeholder="请选择">
                  <el-option v-for="item in options62" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!--line7-->
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="过滤未映射价格：" prop="prePay" style="margin-bottom: 0">
                <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.mapPrice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="过滤现付非协议价：" prop="Fxpay" style="margin-bottom: 0">
                <el-select :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.Fxpay" placeholder="请选择">
                  <el-option v-for="item in options62" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!--line9-->
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="过滤协议价格类型：" prop="prePay" style="margin-bottom: 0">
                <el-select :disabled="posshow" multiple style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.priceType" placeholder="请选择">
                  <el-option v-for="item in options131" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="过滤房型：" prop="Fxpay" style="margin-bottom: 0">
                <el-input :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.roomTypebyKeyWord"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="border">
          <div class="border_title">
            <span>资源方：</span>
          </div>
          <!--line8-->
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="是否是混合搜索：" prop="prePay" style="margin-bottom: 0;">
                <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.hybridModel"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="搜索服务名称：" prop="prePay" style="margin-bottom: 0;">
                <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.serverName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="资源方：" prop="prePay" style="margin-bottom: 0">
                <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.resource" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预定服务名称：" prop="prePay" style="margin-bottom: 0">
                <el-input :disabled="true" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.bookName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="border">
          <div class="border_title">
            <span>公告：</span>
          </div>
          <!--line10-->
          <el-row class="rowtop">
            <el-col :span="24">
              <el-form-item label="公司公告-中文：" prop="ZHNotice" style="margin-bottom: 0; margin-left: 1rem">
                <el-input :disabled="posshow" show-word-limit maxlength="500" type="textarea" style="width: 83%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.ZHNotice"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!--line11-->
          <el-row class="rowtop">
            <el-col :span="24">
              <el-form-item label="公司公告-英文：" prop="ENNotice" style="margin-bottom: 0; margin-left: 1rem">
                <el-input :disabled="posshow" maxlength="1500" show-word-limit type="textarea" style="width: 83%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.ENNotice"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="border" style="margin-left: 17rem;margin-right: 24rem;">
            <div class="border_title">
              <span>列表页公告：</span>
            </div>
            <el-row class="rowtop">
              <el-col :span="12">
                <el-form-item label="默认弹出：" prop="isPopUp" style="margin-bottom: 0;">
                  <el-checkbox :disabled="posshow" v-model="dataForm.isPopUp"></el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="导航栏标签：" prop="isNavigationBarLabel" style="margin-bottom: 0;">
                  <el-checkbox :disabled="posshow" v-model="dataForm.isNavigationBarLabel"></el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标题-中文：" prop="title_CN" style="margin-bottom: 0"  :rules="[
                    {
                      validator: title_CNRule,
                      trigger: 'blur',
                    },
                  ]">
                  <el-input :disabled="posshow" maxlength="10" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.title_CN"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标题-英文：" prop="title_EN" style="margin-bottom: 0" :rules="[
                    {
                      validator: title_ENRule,
                      trigger: 'blur',
                    },
                  ]">
                  <el-input :disabled="posshow" maxlength="20" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.title_EN"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="rowtop">
              <el-col :span="12">
                <el-form-item label="正文-中文：" prop="notice_CN" style="margin-bottom: 0;margin-top: 3rem;">
                  <el-input :disabled="posshow" maxlength="500" show-word-limit type="textarea" style="width: 58%;" class="myselect_inner myicon_inner" v-model="dataForm.notice_CN" :autosize="{ minRows: 15, maxRows: 40}"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="正文-英文：" prop="notice_EN" style="margin-bottom: 0;margin-top: 3rem;">
                  <el-input :disabled="posshow" maxlength="1000" show-word-limit type="textarea" style="width: 58%;" class="myselect_inner myicon_inner" v-model="dataForm.notice_EN" :autosize="{ minRows: 15, maxRows: 40}"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="rowtop">
              <el-col :span="12">
                <el-form-item label="可插入字段：" prop="sysConfigParams" style="margin-bottom: 0">
                  <el-select :disabled="posshow" v-model="dataForm.sysConfigParamChose" placeholder="请选择" style="width: 58%;margin-left: 0px" size="default" @change="selectSysConfigParam(false)">
                    <el-option v-for="item in dataForm.sysConfigParams" :key="item.paramValue" :label="item.paramName" :value="item.paramValue">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="插入位置选择：" prop="positionChose" style="margin-bottom: 0">
                  <el-select :disabled="posshow" v-model="dataForm.positionChose"  style="width: 58%; margin-left: 0px">
                    <el-option key="1" label="中文" value="1"></el-option>
                    <el-option key="2" label="英文" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="border">
          <div class="border_title">
            <span>国家城市屏蔽：</span>
          </div>
          <el-row class="rowtop">
            <el-col :span="24">
              <el-form-item label="屏蔽的国家" prop="ENNotice" style="margin-bottom: 0; margin-left: 1rem">
                <el-select ref="countrySelect" :disabled="posshow" v-model="dataForm.ctcountrycode" multiple filterable placeholder="请选择" style="width: 83%; margin-left: 0px" @change="selectcountryChange">
                  <el-option v-for="item in nationoption" :key="item.countryCode" :label="item.countryName" :value="item.countryCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop" v-show="ctchinatypeshow">
            <el-col :span="24">
              <el-form-item label="屏蔽港澳台" prop="ENNotice" style="margin-bottom: 0; margin-left: 1rem">
                <el-select :disabled="posshow" v-model="dataForm.ctchinatype" multiple filterable placeholder="请选择" style="width: 83%; margin-left: 0px">
                  <el-option key="100000" label="大陆" value="100000"></el-option>
                  <el-option key="810000" label="香港特别行政区" value="810000"></el-option>
                  <el-option key="820000" label="澳门特别行政区" value="820000"></el-option>
                  <el-option key="710000" label="台湾省" value="710000"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="24">
              <el-form-item label="屏蔽的城市" prop="ENNotice" style="margin-bottom: 0; margin-left: 1rem">
                <SelectCity :key="selectCityKey" :setValue="setValue" @func="getCTCity" :disabled="posshow" :country="dataForm.ctcountrycode.toString()" style="width: 83%;margin-left: 0px;background-color: #f5f7fa;border: 1px solid #e4e7ed;padding-left: 5px;padding-right: 5px;"></SelectCity>
              </el-form-item>
            </el-col>
          </el-row>
        </div>  
        <div class="border">
          <div class="border_title">
            <span>酒店集团打标：</span>
          </div>
          <el-row class="rowtop">
            <el-col :span="24">
              <el-form-item label="酒店集团" prop="notRecommendedGorupid" style="margin-bottom: 0; margin-left: 1rem">
                <el-select :disabled="posshow" v-model="dataForm.notRecommendedGorupid" multiple filterable placeholder="请选择" style="width: 83%; margin-left: 0px">
                  <el-option v-for="item in groupList" :key="item.id" :label="item.cName" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop" style="margin-bottom:2rem;">
            <el-col :span="12">
              <el-form-item label="中文描述：" prop="notRecommendedCN" style="margin-bottom: 0;margin-left: 1rem" :rules="[
                        {
                          validator: regNotRecommendedCN,
                          trigger: 'blur',
                        },
                      ]">
                <el-input :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.notRecommendedCN" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="英文描述：" prop="notRecommendedEN" style="margin-bottom: 0;margin-left: 1rem" :rules="[
                        {
                          validator: regNotRecommendedEN,
                          trigger: 'blur',
                        },
                      ]">
                <el-input :disabled="posshow" style="width: 58%; margin-left: 0px" class="myselect_inner myicon_inner" v-model="dataForm.notRecommendedEN"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div> 
        <div class="border">
          <div class="border_title">
            <span>行程单：</span>
          </div>
          <el-row class="rowtop">
            <el-col :span="24">
              <el-form-item label="行程单语言：" style="margin-bottom: 0;">
              <el-col>
                <el-form-item label="大陆" style="margin-bottom: 0;">
                  <el-radio v-model="dataForm.domestic" :disabled="posshow" label="1">中文</el-radio>
                  <el-radio v-model="dataForm.domestic" :disabled="posshow" label="2">英文</el-radio>
                  <el-radio v-model="dataForm.domestic" :disabled="posshow" label="3">按profile语言偏好</el-radio>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="港澳台" style="margin-bottom: 0;">
                  <el-radio v-model="dataForm.gangAoTai" :disabled="posshow" label="1">中文</el-radio>
                  <el-radio v-model="dataForm.gangAoTai" :disabled="posshow" label="2">英文</el-radio>
                  <el-radio v-model="dataForm.gangAoTai" :disabled="posshow" label="3">按profile语言偏好</el-radio>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="国际" style="margin-bottom: 0;">
                  <el-radio v-model="dataForm.international" :disabled="posshow" label="1">中文</el-radio>
                  <el-radio v-model="dataForm.international" :disabled="posshow" label="2">英文</el-radio>
                  <el-radio v-model="dataForm.international" :disabled="posshow" label="3">按profile语言偏好</el-radio>
                </el-form-item>
              </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="是否展示税前价格：" prop="isPretaxPrice" style="margin-bottom: 0;">
                <el-checkbox :disabled="posshow" v-model="dataForm.isPretaxPrice"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="是否展示服务费：" prop="isPretaxPrice" style="margin-bottom: 0;">
                <el-checkbox :disabled="posshow" v-model="dataForm.isServicefree">服务费</el-checkbox>
                <el-checkbox :disabled="posshow" v-model="dataForm.isAdvancepayment">垫资费</el-checkbox>
                <el-checkbox :disabled="posshow" v-model="dataForm.isUrgentfee">紧急服务费</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item label="展示会员卡号及免责条款：" prop="isPretaxPrice" style="margin-bottom: 0;">
                <el-checkbox :disabled="posshow" v-model="dataForm.isShowMembershipCardNo" @change="changeMembershipCardNoCheckbox"></el-checkbox>
                <el-radio-group v-model="dataForm.scopeUse" :disabled="showMembershipCardNoScopeUse" @input="changeScopeUse" style="margin-left: 30px;">
                  <el-radio :label="false">全员</el-radio>
                  <el-radio :label="true">角色</el-radio>
                </el-radio-group>
                <el-select :disabled="showRoleID" v-model="dataForm.roleID" multiple filterable placeholder="请选择" style="width: 83%; margin-left: 0px">
                  <el-option v-for="item in roleoption" :key="item.userLevelValue" :label="item.userLevelName" :value="item.userLevelValue">
                  </el-option>
                </el-select>
                <!-- <el-radio v-model="dataForm.scopeUse" :disabled="showMembershipCardNoScopeUse" label="1">全员</el-radio>
                <el-radio v-model="dataForm.scopeUse" :disabled="showMembershipCardNoScopeUse" label="2">角色</el-radio> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        </div>
      </div>
    </el-form>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
  </div>
</template>

<script>
import {
  pointSaleSave,
  pointSearch,
  getPassengerLevel,
} from "@/api/platformData";
import {
  groupList,
  getcountryList,
} from "@/api/shoppingData";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import SelectCity from "../../components/SelectCity.vue";
import ClientList from "@/components/ClientList.vue";
export default {
  name: "POS",
  components: {
    ConfirmBoxs,
    SelectCity,
    ClientList,
  },
  data() {
    //不推荐集团描述中文英文验证
    var validateNotRecommendedCN = (rule, value, callback) => {
      if (this.dataForm.notRecommendedGorupid.length>0) 
      {
        if(this.dataForm.notRecommendedCN=="")
        {
          callback(new Error(this.$t("请输入不推荐打标中文描述")));
        }
        if(this.dataForm.notRecommendedCN.length>10)
        {
          callback(new Error(this.$t("中文描述最多输入10个字符")));
        }
        callback();
      } else {
        callback();
      }
    };
    var validateNotRecommendedEN = (rule, value, callback) => {
      if (this.dataForm.notRecommendedGorupid.length>0) 
      {
        if(this.dataForm.notRecommendedEN=="")
        {
          callback(new Error(this.$t("请输入不推荐打标英文描述")));
        }
        if(this.dataForm.notRecommendedEN.length>50)
        {
          callback(new Error(this.$t("英文描述最多输入50个字符")));
        }
        callback();
      } else {
        callback();
      }
    };
    //列表页公告中文验证
    var validateTitleCN = (rule, value, callback) => {
      if(this.dataForm.isPopUp || this.dataForm.isNavigationBarLabel)
      {
        if (value==undefined || value==null || value=="") {
          callback(new Error(this.$t("请输入中文标题名称")));
        } else {
          callback();
        }
      }
      callback();
    };
    //列表页公告英文验证
    var validateTitleEN = (rule, value, callback) => {
      if(this.dataForm.isPopUp || this.dataForm.isNavigationBarLabel)
      {
        if (value==undefined || value==null || value=="") {
          callback(new Error(this.$t("请输入英文标题名称")));
        } else {
          callback();
        }
      }
      callback();
    };
    //差规浮窗文本中文验证
    var validateTripRuleCN = (rule, value, callback) => {
      if(this.dataForm.isFloatWindowPersonalization)
      {
        if ((value==undefined || value==null || value=="") && this.dataForm.descEn) {
          callback(new Error(this.$t("请输入中文描述")));
        } else {
          let newStr = value.replace(/\{[^}]+\}/g, "");
          if(newStr.length > 20 ){
            callback(new Error(this.$t("中文描述最多输入20个字符")));
          }else{
            callback();
          }
        }
      }
      callback();
    };
    //差规浮窗文本英文验证
    var validateTripRuleEN = (rule, value, callback) => {
      if(this.dataForm.isFloatWindowPersonalization )
      {
        if ((value==undefined || value==null || value=="") && this.dataForm.descCn) {
          callback(new Error(this.$t("请输入英文文描述")));
        } else {
          let newStr = value.replace(/\{[^}]+\}/g, "");
          if(newStr.length > 30 ){
            callback(new Error(this.$t("英文描述最多输入30个字符")));
          }else{
            callback();
          }
        }
      }
      callback();
    };
    return {
      clientListFlag: false,
      addlocation: "",
      selecttype: 0,
      selectnation: "",
      selectprovince: "",
      // paramsCitycode: "",
      citycode: "",
      cityCode: "",
      cityCodesearch: "",
      searchForm: {
        client: "",
      },
      nationoption: [],
      //POS
      posshow: true,
      isShowTripRule: true,
      searchData: "",
      btnshow: "",
      btnstatus: "",
      posResult: "",
      setValue: [],
      selectCityKey: 0,
      dataForm: {
        maxNights: "",
        maxPerson: "",
        maxHotel: "", //每页条数
        maxRoom: "",
        maxAdvanceday: "",
        defultCry: "",
        hybridModel: "",
        serverName: "",
        value: "",
        prePay: "",
        NonGuaratee: "", //t
        outofPolicy: "", //t
        agentOutOfPolicy: "",
        mapPrice: "", //过滤
        nonRefund: "", //f
        Fxpay: "",
        burPrice: "", //f
        resource: "",
        bookName: "",
        ENNotice: "",
        ZHNotice: "",
        ctcountrycode: "",
        ctcitycode: "",
        ctcityname: "",
        selctctiy: [],
        ctchinatype: [],
        priceType:"",
        notRecommendedGorupid:[],//不推荐酒店集团列表
        notRecommendedCN:"",//不推荐酒店集团中文描述
        notRecommendedEN:"",//不推荐酒店集团英文描述
        title_CN: "",
        title_EN: "",
        notice_CN:"",
        notice_EN:"",
        isPopUp: false,
        isNavigationBarLabel: false,
        positionChose: "1", 
        sysConfigParams:[],
        sysConfigParamChose:"",
        //IsTripRuleMark: true,
        descCn: "",
        descEn: "",
        isFloatWindowPersonalization: false,
        isTripRuleMarkInHotelList: false,
        isTripRule: true,
        posFloatChose: "1", 
        sysParamPosFloatChose:"",
        checkedProducts:[],
        openResource_payNow:"",
        openResource_publicPay:"",
        openResources_D:["1"],//国内
        openResources_I:["1"],//国际
        openResources_O:["1"],//港澳台
        domestic:"3",
        gangAoTai:"3",
        international:"3",
        isPretaxPrice:false,
        roomTypebyKeyWord:"",
        isShowChainWide: true,
        isServicefree: true,
        isAdvancepayment: true,
        isUrgentfee: true,
        isOpenLatterApproval: false,
        isShowMembershipCardNo:false,
        scopeUse:false,
        roleID:[],
        tripRuleChecked: [], // 选中的差规标识
        isShowChannel:false,//是否展示渠道
        onlyShowBestPrice:false,//只展示最优价格
        invoicingMethods:'',//开票方式
        // isItineraryCn:true,
        // isItineraryEn:true,
        // isItineraryGAT:true, 
      },
      ctchinatypeshow: false, //屏蔽港澳台是否显示
      regNotRecommendedCN:validateNotRecommendedCN,
      regNotRecommendedEN:validateNotRecommendedEN,
      title_CNRule:validateTitleCN,
      title_ENRule:validateTitleEN,
      tripRule_cn:validateTripRuleCN,
      tripRule_en:validateTripRuleEN,
      rules: {
        maxNights: [
          { required: true, message: "请输入30以内天数", trigger: "blur" },
          { pattern: /^([12][0-9]|30|[1-9])$/, message: "请输入0-30整数",trigger: "blur",},
        ],
        maxAdvanceday: [
          { required: true, message: "请输入366以内天数", trigger: "blur" },
          { pattern: /^(0?[0-9]?[0-9]|[1-2][0-9][0-9]|3[0-5][0-9]|36[0-6])$/,message: "请输入0-366整数",trigger: "blur",},
        ],
        maxHotel: [
          { required: true, message: "请输入20以内条数", trigger: "blur" },
          { pattern: /^([1-9]|(1[0-9]|2[0]))$/,message: "请输入1-20整数",trigger: "blur",},
        ],
      },

      options: [
        { value: "WEB", label: "WEB",},
        { value: "MOBILE", label: "MOBILE",},
      ],
      options32: [
        //过滤非担保价格
        { value: true, label: "是",},
        { value: false, label: "否",},
      ],
      options42: [
        //超标管控
        { value: false,label: "是",},
        { value: true, label: "否",},
      ],
      options52: [
        //过滤延时预定价格
        { value: true, label: "是",},
        { value: false, label: "否",},
      ],
      options62: [
        //过滤不可取消价格
        { value: true, label: "是",},
        { value: false, label: "否",},
      ],
      options122: [
        //过滤付迅现付资源
        { value: true, label: "是",},
        { value: false, label: "否",},
      ],
      options131: [
        //过滤协议价格类型
        { value: "1", label: "AP",},
        { value: "2", label: "Others",},
        { value: "3", label: "CP",},
      ],
      optionsMaxPerson: [
        //每间人数
        { value: 1, label: "1",},
        { value: 2, label: "2",},
      ],
      //新增dialog
      cityIdform: "",
      cityCodeform: "",
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      addprovince: "",
      addcity: "",
      addnation: "",
      adddialogprovince: "",
      adddialogcity: "",
      adddialognation: "",
      operationType: "",
      showAgentOutOfPolicy: true,
      ShowChannel: false,
      countryList: [],
      value1: [],
      groupList:[],//酒店集团列表
      openResource:[
        {key:"1",value:"现付"},
        {key:"3",value:"公付"},
        {key:"2",value:"在线付"},
      ],
      showMembershipCardNoScopeUse:true,
      showRoleID:true,
      roleoption: [],
    };
  },
  mounted() {
    this.getGroupList();
    this.getCountryList();
  },
  computed:{
    isFloat(){
      //return this.posshow? this.posshow : !this.dataForm.isFloatWindowPersonalization;
      if(!this.posshow){
        if(this.dataForm.isTripRule){
          return !this.dataForm.isFloatWindowPersonalization;
        }
      }
      return true;
    }
  },
  methods: {
    closeDialog(form) {
      // console.log(form);
      // this.$refs[form].resetFields();
      form.searchClient = "";
      form.searchClientNo = "";
    },
    //========================================POS
    //选择客户
    selectClient(item) {
      this.hotelCustomerCode = item.customerCode;
      this.searchForm.client = item.customerName;
      this.$refs['posruleForm'].resetFields();
      this.searchRusult();
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    // API-search
    async searchRusult() {
      await this.getPassengerLevel().then(()=>{
        let customerParam = {
        params: {
          customerCode: this.hotelCustomerCode,
          // channelID: this.$objBaseInfo.channelId,暂时不传，如果传后端要改逻辑
        },
      };
      let that = this;
      pointSearch(customerParam)
        .then((res) => {
          //console.log("search POS结果", res.data.list);
          that.posshow = true;
          this.posResult = res.data.list;
          that.btnshow = 1;
          if (res.data.list.length == 0) {
            that.btnshow = 3;
            that.dataForm = that.$options.data().dataForm;
            that.setValue = [];
          } else {
            this.searchData = res.data.list[0];
            let resData = this.searchData.hotelSettings[0];
            let hybire = resData.hybridSearchModel == true ? "是" : "否";
            let prePay = resData.filterRepayRates == true ? "是" : "否"; //预付
            let NonGuaratee =
              resData.filterNonGdsguarabteeRates == true ? "是" : "否"; //非担保
            let outofPolicy =
              resData.enableOutOfPolicyControl == true ? "否" : "是"; //超标
            let agentOutofPolicy = resData.enableAgentOutOfPolicyControl; //超标
            let mapPrice = resData.filterUnmappedRates == true ? "是" : "否"; //映射
            let nonRefund =
              resData.filterNonRefundableRates == true ? "是" : "否"; //非退款
            let Fxpay = resData.filterFxpayHotel == true ? "是" : "否"; //非退款
            let burPrice = resData.filterBurRates == true ? "是" : "否"; //延时
            let defultCry = res.data.list[0].uiSettings[0].defaultCurrencyCode;
            let resource =
              res.data.list[0].hRemoteSystemSettingotelSettings[0]
                .remoteSystemCode;
            //console.log("POS信息", this.searchData);
            const products = [];
            if (resData.bookOtherPc) products.push('PC')
            if (resData.bookOtherH5) products.push('H5')
            this.dataForm.checkedProducts = products;
            that.dataForm.maxNights = resData.maximumNumberNights; //最大预定间夜数
            that.dataForm.maxAdvanceday = resData.maximumDaysAdvance; //最长的提前天数
            that.dataForm.maxPerson = resData.maximumNumberAdultsAllowedRoom; //每间人数
            that.dataForm.maxHotel = resData.maximumNumberProperties; //最大预订酒店数
            that.dataForm.maxRoom = resData.maximumNumberRooms; //最大预订房间数
            that.dataForm.isShowChainWide = resData.isShowChainWide;//是否展示ChainWide酒店标识
            that.dataForm.isShowChannel = resData.isShowChannel;//是否展示渠道
            that.dataForm.hybridModel = hybire; //是否是混合搜索
            that.dataForm.defultCry = defultCry; //默认货币
            that.dataForm.prePay = prePay; //过滤预付
            that.dataForm.NonGuaratee = NonGuaratee; //过滤
            that.dataForm.outofPolicy = outofPolicy; //过滤
            that.dataForm.agentOutOfPolicy = agentOutofPolicy; //过滤
            that.dataForm.mapPrice = mapPrice; //过滤
            that.dataForm.nonRefund = nonRefund; //过滤
            that.dataForm.Fxpay = Fxpay; //过滤
            that.dataForm.burPrice = burPrice;
            that.dataForm.resource = resource;
            that.dataForm.isOpenLatterApproval = resData.isOpenLatterApproval; //开启行后审批
            that.dataForm.onlyShowBestPrice = resData.onlyShowBestPrice; //仅展示最优价格
            that.dataForm.ZHNotice = this.searchData.uiSettings[0].notice["zh-CN"];
            that.dataForm.ENNotice = this.searchData.uiSettings[0].notice.en;
            that.dataForm.invoicingMethods = resData.invoicingMethods;
            if (res.data.list[0].connectorSettings[0].serviceName == "hotel_shopping") {
              that.dataForm.serverName = res.data.list[0].connectorSettings[0].connectorLocator; // 搜索服务名称
              that.dataForm.bookName = res.data.list[0].connectorSettings[1].connectorLocator; // 预定服务名称
            } else {
              that.dataForm.bookName = res.data.list[0].connectorSettings[0].connectorLocator; // 预定服务名称
              that.dataForm.serverName = res.data.list[0].connectorSettings[1].connectorLocator; // 搜索服务名称
            }
            var arrIntSet = []
            if (resData.filterPriceType != null && resData.filterPriceType !== '') {
              var arrString = resData.filterPriceType.split(',')
              for (var arrInt in arrString) {
                arrIntSet.push(arrString[arrInt])
              }
            }
            that.dataForm.priceType = arrIntSet;
            //清空值，防止切换的时候带入上一个的内容参数
            this.dataForm.ctcountrycode = [];
            this.dataForm.ctcitycode = "";
            this.dataForm.ctcityname = "";
            this.dataForm.ctchinatype = "";
            this.setValue = [];
            this.dataForm.selctctiy = [];
            this.ctchinatypeshow = false;
            if (
              res.data.list[0].ctCity != undefined &&
              res.data.list[0].ctCity != null &&
              res.data.list[0].ctCity != ""
            ) {
              if (
                res.data.list[0].ctCity.countryCode != undefined &&
                res.data.list[0].ctCity.countryCode != null &&
                res.data.list[0].ctCity.countryCode != ""
              ) {
                this.dataForm.ctcountrycode =
                  res.data.list[0].ctCity.countryCode.split(",");
                if (this.dataForm.ctcountrycode.indexOf("100000") >= 0) {
                  this.ctchinatypeshow = true;
                } else {
                  this.ctchinatypeshow = false;
                }
              } else {
                this.dataForm.ctcountrycode = [];
              }
              if (
                res.data.list[0].ctCity.cityName != undefined &&
                res.data.list[0].ctCity.cityName != null &&
                res.data.list[0].ctCity.cityName != "" &&
                res.data.list[0].ctCity.cityCode != undefined &&
                res.data.list[0].ctCity.cityCode != null &&
                res.data.list[0].ctCity.cityCode != ""
              ) {
                this.dataForm.ctcitycode = res.data.list[0].ctCity.cityCode;
                this.dataForm.ctcityname = res.data.list[0].ctCity.cityName;
                let arr_ctcitycode = this.dataForm.ctcitycode.split(",");
                let arr_ctcityname = this.dataForm.ctcityname.split(",");
                for (let i = 0; i < arr_ctcitycode.length; i++) {
                  if (arr_ctcityname.length >= i) {
                    let model = {
                      name: arr_ctcityname[i],
                      code: arr_ctcitycode[i],
                    };
                    this.setValue.push(model);
                    this.dataForm.selctctiy.push(model);
                  }
                }
              }
              if (
                res.data.list[0].ctCity.chinaType != undefined &&
                res.data.list[0].ctCity.chinaType != null &&
                res.data.list[0].ctCity.chinaType != ""
              ) {
                this.dataForm.ctchinatype =
                  res.data.list[0].ctCity.chinaType.split(",");
              } else {
                this.dataForm.ctchinatype = [];
              }
            }
            //判断是否存在不推荐打标酒店集团列表
            if(res.data.list[0].hasOwnProperty("notRecommendedModel"))
            {
                this.dataForm.notRecommendedCN=res.data.list[0].notRecommendedModel.notRecommendedCN;
                this.dataForm.notRecommendedEN=res.data.list[0].notRecommendedModel.notRecommendedEN;
                if(res.data.list[0].notRecommendedModel.notRecommendedGorupid!=undefined && res.data.list[0].notRecommendedModel.notRecommendedGorupid!="" && res.data.list[0].notRecommendedModel.notRecommendedGorupid.split(",").length>0)
                {
                  this.dataForm.notRecommendedGorupid=res.data.list[0].notRecommendedModel.notRecommendedGorupid.split(",");
                }
            }
            else
            {
                this.dataForm.notRecommendedCN="";
                this.dataForm.notRecommendedEN="";
                this.dataForm.notRecommendedGorupid=[];
            }
            //判断行程单是否显示差规标识
            if(res.data.list[0].hasOwnProperty("posItineraryModel"))
            {
                //this.dataForm.IsTripRuleMark = res.data.list[0].posItineraryModel.isTripRuleMark;
                this.dataForm.isPretaxPrice = res.data.list[0].posItineraryModel.isPretaxPrice;
                this.dataForm.isServicefree = res.data.list[0].posItineraryModel.isServicefree;
                this.dataForm.isAdvancepayment = res.data.list[0].posItineraryModel.isAdvancepayment;
                this.dataForm.isUrgentfee = res.data.list[0].posItineraryModel.isUrgentfee;
                this.dataForm.isShowMembershipCardNo = res.data.list[0].posItineraryModel.isShowMembershipCardNo;
                this.dataForm.scopeUse = res.data.list[0].posItineraryModel.scopeUse;
                // this.dataForm.isItineraryCn = res.data.list[0].posItineraryModel.isCn;
                // this.dataForm.isItineraryEn = res.data.list[0].posItineraryModel.isEn;
                // this.dataForm.isItineraryGAT = res.data.list[0].posItineraryModel.isGat;
                if(res.data.list[0].posItineraryModel.roleId!=undefined && res.data.list[0].posItineraryModel.roleId!="" && res.data.list[0].posItineraryModel.roleId.split(",").length>0)
                {
                  this.dataForm.roleID = res.data.list[0].posItineraryModel.roleId.split(",");
                }else{
                  this.dataForm.roleID = [];
                }
                this.changeMembershipCardNoCheckbox(this.dataForm.isShowMembershipCardNo);
            }else{
              this.dataForm.roleID = [];
            }
            //列表页公告
            if(res.data.list[0].uiAnnoucementSettings.length > 0){
              var annoucementData = res.data.list[0].uiAnnoucementSettings[0];
              that.dataForm.isPopUp = annoucementData.isPopUp; //默认弹出
              that.dataForm.isNavigationBarLabel = annoucementData.isNavigationBarLabel; //导航栏标签
              that.dataForm.notice_CN = annoucementData.notice["zh-CN"]; //标题-中文
              that.dataForm.notice_EN = annoucementData.notice["en"]; //标题-英文
              that.dataForm.title_CN = annoucementData.title["zh-CN"]; //正文-中文
              that.dataForm.title_EN = annoucementData.title["en"]; //正文-英文
            }
            var arrsysConfigParamChose = []
            if (this.searchData.sysConfigParams != null && this.searchData.sysConfigParams !== '') {
              for (let i = 0; i < this.searchData.sysConfigParams.length; i++) {
                var arrInfo = this.searchData.sysConfigParams[i];
                let model = {
                  paramName: arrInfo.paramName,
                  paramValue: arrInfo.paramValue,
                };
                arrsysConfigParamChose.push(model)
              }
            }
            that.dataForm.sysConfigParams = arrsysConfigParamChose;
            //差规浮窗设置
            if(res.data.list[0].hasOwnProperty("posHotelTravelRule")){
              var travelRule = res.data.list[0].posHotelTravelRule;
              that.dataForm.descCn = travelRule.descCn; 
              that.dataForm.descEn = travelRule.descEn; 
              that.dataForm.isFloatWindowPersonalization = travelRule.isFloatWindowPersonalization; 
              that.dataForm.isTripRuleMarkInHotelList = travelRule.isTripRuleMarkInHotelList;
              that.dataForm.isTripRule = travelRule.isShowTravelTitle;
              const checked = []
              if (travelRule.isCn) checked.push('CN')
              if (travelRule.isGat) checked.push('GAT')
              if (travelRule.isEn) checked.push('EN')
              this.dataForm.tripRuleChecked = checked
            }else{
              that.dataForm.descCn = ''; 
              that.dataForm.descEn = ''; 
              that.dataForm.isFloatWindowPersonalization = false; 
              that.dataForm.isTripRuleMarkInHotelList = true;
              that.dataForm.isTripRule  = true;
              const checked = ['CN','GAT','EN'];
              this.dataForm.tripRuleChecked = checked;
            }
            //判断是否有开通资源
            if(resData.hasOwnProperty("openResource"))
            {
               var data = JSON.parse(resData.openResource);
               that.dataForm.openResources_D = data.Domestic; 
               that.dataForm.openResources_I = data.International; 
               that.dataForm.openResources_O = data.GangAoTai; 
            }else{
               that.dataForm.openResources_D = ["1"]; 
               that.dataForm.openResources_I = ["1"]; 
               that.dataForm.openResources_O = ["1"]; 
            }
            //判断行程单语言
            if(resData.itineraryLanguageSet)
            {
               var data = JSON.parse(resData.itineraryLanguageSet);
               //that.dataForm.type = data.Type; 
               that.dataForm.domestic = data.AreaItem.Domestic; 
               that.dataForm.gangAoTai = data.AreaItem.GangAoTai; 
               that.dataForm.international = data.AreaItem.International; 
            }else{
               //that.dataForm.type = "1"; 
               that.dataForm.domestic = "3"; 
               that.dataForm.gangAoTai = "3"; 
               that.dataForm.international = "3"; 
            }
            //判断是否存在屏蔽房型
            if(resData.hasOwnProperty("filterRoomTypebyKeyWord"))
            {
              this.dataForm.roomTypebyKeyWord = resData.filterRoomTypebyKeyWord;
            }
            
          }
          this.selectCityKey++;
        })
        .catch(function (error) {
          //.log("POS 请求失败", error.objError);
        });
      })
    },
    selectcountryChange(value) {
      if (value.indexOf("100000") >= 0) {
        this.ctchinatypeshow = true;
      } else {
        this.ctchinatypeshow = false;
      }
      this.$nextTick(() => {
        const countrySelect = this.$refs.countrySelect;
        if (countrySelect && countrySelect.states) {
          countrySelect.states.inputValue = "";
          if (typeof countrySelect.handleQueryChange === "function") {
            countrySelect.handleQueryChange("");
          }
        }
      });
    },
    getCTCity(pararm) {
      this.dataForm.selctctiy = pararm;
    },
    // btn
    cancel(formRule) {
      this.searchRusult();
      this.$refs[formRule].resetFields();
    },
    editPos(status) {
      this.btnstatus = status;
      this.btnshow = 2;
      this.posshow = false;
      if (this.btnstatus == "add") {
        this.dataForm.maxNights = 30; //最大预定间夜数
        this.dataForm.maxAdvanceday = 90; //最长的提前天数
        this.dataForm.maxPerson = 1; //每间人数
        this.dataForm.maxHotel = 10; //最大预定酒店数
        this.dataForm.maxRoom = 1; //最大预定房间数
        this.dataForm.hybridModel = "否"; //是否是混合搜索 否
        this.dataForm.defultCry = "CNY"; //默认货币
        this.dataForm.prePay = "是"; //过滤预付
        this.dataForm.NonGuaratee = this.options32[1].label;
        this.dataForm.outofPolicy = this.options42[0].label;
        this.dataForm.mapPrice = "否";
        this.dataForm.nonRefund = this.options62[1].label;
        this.dataForm.Fxpay = this.options122[0].label;
        this.dataForm.burPrice = this.options52[1].label;
        this.dataForm.resource = "Fuxun";
        this.dataForm.serverName = "FXHotelShoppingConnector";
        this.dataForm.bookName = "FXHotelBookingConnector";
      }
      this.showAgentOutOfPolicy =
        this.dataForm.outofPolicy == "是" ? false : true;
      this.changeMembershipCardNoCheckbox(this.dataForm.isShowMembershipCardNo)
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //this.searchData =res.data.list[0] this.posResult= res.data.list= []
          let filterData = this.searchData
            ? this.searchData.hotelSettings[0]
            : "";
          let hybridSearchModel = filterData.hybridSearchModel
            ? filterData.hybridSearchModel
            : false;
          let filterUnmappedRates = filterData.filterUnmappedRates
            ? filterData.filterUnmappedRates
            : false;
          let filterRepayRates = filterData.filterRepayRates
            ? filterData.filterRepayRates
            : true;

          let filterFxpayHotel = this.dataForm.Fxpay;
          if (filterFxpayHotel == "否") {
            filterFxpayHotel = false;
          } else if (filterFxpayHotel == "是") {
            filterFxpayHotel = true;
          }
          let filterNonRefundableRates = this.dataForm.nonRefund;
          if (filterNonRefundableRates == "否") {
            filterNonRefundableRates = false;
          } else if (filterNonRefundableRates == "是") {
            filterNonRefundableRates = true;
          }
          let filterNonGdsguarabteeRates = this.dataForm.NonGuaratee;
          if (filterNonGdsguarabteeRates == "否") {
            filterNonGdsguarabteeRates = false;
          } else if (filterNonGdsguarabteeRates == "是") {
            filterNonGdsguarabteeRates = true;
          }
          let filterBurRates = this.dataForm.burPrice;
          if (filterBurRates == "否") {
            filterBurRates = false;
          } else if (filterBurRates == "是") {
            filterBurRates = true;
          }
          let enableAgentOutOfPolicyControl = false;
          let enableOutOfPolicyControl = this.dataForm.outofPolicy;
          if (enableOutOfPolicyControl == "是") {
            enableOutOfPolicyControl = false;
            enableAgentOutOfPolicyControl = this.dataForm.agentOutOfPolicy;
          } else if (enableOutOfPolicyControl == "否") {
            enableOutOfPolicyControl = true;
          }
          this.dataForm.ctcitycode = "";
          this.dataForm.ctcityname = "";
          if (this.dataForm.selctctiy.length > 0) {
            for (let i = 0; i < this.dataForm.selctctiy.length; i++) {
              this.dataForm.ctcitycode +=
                this.dataForm.selctctiy[i].code +
                (i != this.dataForm.selctctiy.length - 1 ? "," : "");
              this.dataForm.ctcityname +=
                this.dataForm.selctctiy[i].name +
                (i != this.dataForm.selctctiy.length - 1 ? "," : "");
            }
          }
          let filterPriceType = "";
          if (this.dataForm.priceType.length > 0) {
            for (let i = 0; i < this.dataForm.priceType.length; i++) {
              filterPriceType += this.dataForm.priceType[i] + (i != this.dataForm.priceType.length - 1 ? "," : "");
            }
          }
          let Param = {
            // "id": 0,
            // "poscode": "ACN_HBE", //
            posname: this.searchForm.client, //客户名称
            parentPoscode: "",
            companyGuid: this.hotelCustomerCode, //getCustomerLookup取到customerCode传给companyGuid
            channelId: "",
            connectorSettings: [
              { serviceName: "hotel_shopping", connectorLocator: "FXHotelShoppingConnector",},
              { serviceName: "hotel_booking", connectorLocator: "FXHotelBookingConnector",},
            ],
            hotelSettings: [
              {
                maximumNumberNights: parseInt(this.dataForm.maxNights), //defult 15 max=15
                maximumNumberRooms: parseInt(this.dataForm.maxRoom),
                maximumNumberAdultsAllowedRoom: parseInt(this.dataForm.maxPerson),
                maximumDaysAdvance: parseInt(this.dataForm.maxAdvanceday), //defult 90 max=90
                maximumNumberProperties: parseInt(this.dataForm.maxHotel),
                hybridSearchModel: hybridSearchModel,
                filterUnmappedRates: filterUnmappedRates,
                filterRepayRates: filterRepayRates,
                filterNonRefundableRates: filterNonRefundableRates, //false can change
                filterFxpayHotel: filterFxpayHotel, //false can change
                filterNonGdsguarabteeRates: filterNonGdsguarabteeRates, // true can change
                filterBurRates: filterBurRates, //false can change
                enableOutOfPolicyControl: enableOutOfPolicyControl, //true can change
                enableAgentOutOfPolicyControl: enableAgentOutOfPolicyControl,
                filterPriceType: filterPriceType,// 过滤协议价格类型
                bookOtherH5: this.dataForm.checkedProducts.includes('H5'),
                bookOtherPC: this.dataForm.checkedProducts.includes('PC'),
                openResource:JSON.stringify({Domestic:this.dataForm.openResources_D,GangAoTai:this.dataForm.openResources_O,International:this.dataForm.openResources_I}),
                itineraryLanguageSet:JSON.stringify({AreaItem:{Domestic:this.dataForm.domestic,GangAoTai:this.dataForm.gangAoTai,International:this.dataForm.international}}),
                filterRoomTypebyKeyWord:this.dataForm.roomTypebyKeyWord,
                isShowChainWide:this.dataForm.isShowChainWide,
                isOpenLatterApproval:this.dataForm.isOpenLatterApproval,
                isShowChannel:this.dataForm.isShowChannel,
                onlyShowBestPrice:this.dataForm.onlyShowBestPrice,
                invoicingMethods:this.dataForm.invoicingMethods,
              },
            ],
            paytypeSettings: [
              {
                paymentType: 0, //unnus
                formOfPayment: "CREDITCARD", //?非必填？
              },
            ],
            remoteSystemSettings: [
              {
                remoteSystemCode: "Fuxun", //ziyuanfang
                connectionDetails: "",
              },
            ],
            uiSettings: [
              {
                defaultLanguageCode: "zh-CN", //
                defaultCurrencyCode: "CNY", //defult currency
                Notice: {
                  en: this.dataForm.ENNotice,
                  "zh-CN": this.dataForm.ZHNotice,
                },
              },
            ],
            uiAnnoucementSettings:[
              {
                defaultLanguageCode: "zh-CN",
                defaultCurrencyCode: "CNY",
                notice: {
                  "zh-CN": this.dataForm.notice_CN,
                  "en": this.dataForm.notice_EN,
                },
                title: {
                  "zh-CN": this.dataForm.title_CN,
                  "en": this.dataForm.title_EN,
                },
                isPopUp: this.dataForm.isPopUp,
                isNavigationBarLabel: this.dataForm.isNavigationBarLabel
              },
            ],
            CTCity: {
              CountryCode: this.dataForm.ctcountrycode.toString(), //国家code
              CityCode: this.dataForm.ctcitycode,
              CityName: this.dataForm.ctcityname,
              ChinaType: this.ctchinatypeshow?this.dataForm.ctchinatype.toString():"",
            },
            NotRecommendedModel:{
              NotRecommendedGorupid:this.dataForm.notRecommendedGorupid.toString(),//不推荐酒店集团列表
              NotRecommendedCN:this.dataForm.notRecommendedCN,
              NotRecommendedEN:this.dataForm.notRecommendedEN,
            },
            PosItineraryModel:{
              //IsTripRuleMark: this.dataForm.IsTripRuleMark,//是否显示差规标识
              IsPretaxPrice: this.dataForm.isPretaxPrice,//是否展示税前价格
              IsServicefree: this.dataForm.isServicefree,//是否展示服务费
              IsAdvancepayment: this.dataForm.isAdvancepayment,//是否展示垫资费
              IsUrgentfee: this.dataForm.isUrgentfee,//是否展示紧急服务费
              IsShowMembershipCardNo: this.dataForm.isShowMembershipCardNo,//展示会员卡号及免责条款
              ScopeUse: this.dataForm.scopeUse,//展示会员卡号涉及到的范围，false是全员，true是角色
              RoleID: this.dataForm.roleID.toString(),//展示会员卡号 选择角色时应对应的旅客级别
              isCn: this.dataForm.tripRuleChecked.includes('CN'),//是否显示差规-国内
              isEn: this.dataForm.tripRuleChecked.includes('EN'),//是否显示差规-国外
              isGat: this.dataForm.tripRuleChecked.includes('GAT'),//是否显示差规-港澳台
            },
            posHotelTravelRule:{
              isTripRuleMarkInHotelList:this.dataForm.isTripRuleMarkInHotelList,
              isFloatWindowPersonalization:this.dataForm.isFloatWindowPersonalization,
              isShowTravelTitle : (this.dataForm.isHotelTravelRuleCn || this.dataForm.isHotelTravelRuleEn || this.dataForm.isHotelTravelRuleGAT)?this.dataForm.isTripRule:false,
              descCn:this.dataForm.descCn,
              descEn:this.dataForm.descEn,
              isCn: this.dataForm.tripRuleChecked.includes('CN'),//是否显示差规-国内
              isEn: this.dataForm.tripRuleChecked.includes('EN'),//是否显示差规-国外
              isGat: this.dataForm.tripRuleChecked.includes('GAT'),//是否显示差规-港澳台
            },
          };
          if (this.btnstatus == "edit") {
            Param.poscode = this.searchData.poscode;
          }
          pointSaleSave(Param)
            .then((res) => {
              console.log("save POS信息", res);
            })
            .catch(function (error) {
              console.log("save POS 请求失败", error.objError);
            });
          this.confirmFlag = true;
          this.confirmMsg = "保存成功";
          this.btnshow = "1";
          this.posshow = true;
          this.showAgentOutOfPolicy = true;
          this.showMembershipCardNoScopeUse = true;
        } else {
          this.confirmFlag = true;
          this.confirmMsg = "请选择合适范围";
          return false;
        }
      });
    },
    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    selectOutofPolicy(value) {
      this.showAgentOutOfPolicy = value;
    },
    //获取酒店集团列表
    async getGroupList(int) {
      this.submitLoading = true;
      let searchparams = {
        params: {
          page: 1,
          pageSize: 1000,
        },
      };
      await groupList(searchparams)
        .then((res) => {
          this.groupList = res.data.list;
        })
        .catch(function (error) {
          console.log("请求失败", error.objError);
        });
    },
    selectSysConfigParam(val){
      if(val){
        if(this.dataForm.posFloatChose == 1){
          this.dataForm.descCn = this.dataForm.descCn + this.dataForm.sysParamPosFloatChose;
        }else{
          this.dataForm.descEn = this.dataForm.descEn + this.dataForm.sysParamPosFloatChose;
        }
      }else{
        if(this.dataForm.positionChose == 1){
          this.dataForm.notice_CN = this.dataForm.notice_CN + this.dataForm.sysConfigParamChose;
        }else{
          this.dataForm.notice_EN = this.dataForm.notice_EN + this.dataForm.sysConfigParamChose;
        }
      }
    },
    //获取搜索下拉值-国省市
    async getCountryList() {
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          this.nationoption = res.data.list;
        });
    },
    tripRuleChange(){
      this.dataForm.isTripRule = (this.dataForm.tripRuleChecked.includes('CN') || this.dataForm.tripRuleChecked.includes('EN') || this.dataForm.tripRuleChecked.includes('GAT')) ? true : false;
      //this.dataForm.IsTripRuleMark = (this.dataForm.isItineraryCn || this.dataForm.isItineraryEn || this.dataForm.isItineraryGAT)?this.dataForm.IsTripRuleMark:false;
    },
    changeMembershipCardNoCheckbox(value){
      this.showMembershipCardNoScopeUse = !value;
      if(!value){
        this.showRoleID = !value;
      }else{
        this.showRoleID = !this.dataForm.scopeUse;
      }
      if(this.posshow){
        this.showRoleID = this.posshow;
        this.showMembershipCardNoScopeUse = this.posshow;
      }
    },
    changeScopeUse(){
      this.showRoleID = !this.dataForm.scopeUse;
    },
    async getPassengerLevel(){
      let searchparams = {
        params: {
          customerCode: this.hotelCustomerCode,
        },
      };
      await getPassengerLevel(searchparams)
        .then((res) => {
          this.roleoption = [];
          if(res.code == 200 && res.data.error.code == 0){
            this.roleoption = res.data.passengerLevelData;
            console.log(this.roleoption)
          }
        });
    }
  },
};
</script>

<style scoped>
.rowtop {
  margin-top: 1.5rem;
  margin-left: 16rem;
}

.pos_container_panel {
  /*padding: 0 16rem 4rem;*/
  padding-bottom: 4rem;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  display: flex;
}
.border{
  margin-top: 3rem;
  margin-left: 2rem;
  padding-bottom: 1rem;
  border: 3px solid darkgray;
  border-radius: 4px;
}
.border_title{
  font-size: 14px;
  width: 110px;
  background: #fff;
  text-align: center;
  margin-top: -1.2rem;
  margin-left: 1rem;
}
</style>
